export default [
  'installed',
  'savedSettings',
  'testedConnection',
  'toggledActive',
  'uninstalled'
]
